<template>
  <report-list
    :type="type"
    :reportService="reportService"
  ></report-list>
</template>

<script>
import ReportList from '@/components/Common/Report/ReportList'
import reportService from '@/services/licensor/report'

export default {
  created () {
    this.$store.commit('UPDATE_TITLE', 'Analytics')
  },

  components: {
    ReportList
  },

  data () {
    return {
      type: 'licensor',
      reportService: reportService
    }
  }
}
</script>

<style lang="stylus">
.clickable
  tr:hover
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/Licensor/Reports.vue